/**
 * The rule catalog (contracts/ui-api.md "Rule catalog (sheet 04)"; ANA.3, ANA.6,
 * ANA.7; DM-01M3BGSYXX5C2KHX81NNMGD5G6: read-only over GET /v1/rules).
 */
import { api, ruleIdSegment } from '../api'
import type { Severity } from '../severity'

/** backend/internal/rules/catalog.go: approved, draft or placeholder. */
export type ExplanationStatus = 'approved' | 'draft' | 'placeholder' | (string & {})

export interface RuleSummary {
  id: string
  default_severity: Severity
  description: string
  segment: string
  field: string | null
  crrg_ref: string
  explanation: { status: ExplanationStatus }
}

/** GET /v1/rules: `count` is the rule count screens render, never a literal (T1, T3). */
export interface RulesList {
  rule_set_version: string
  count: number
  /** Rendered verbatim (ANA.7). */
  statement: string
  rules: RuleSummary[]
}

export interface RuleExplanationBody {
  status: ExplanationStatus
  what_it_checks: string | null
  why_it_matters: string | null
  common_causes: string | null
  suggested_fix: { data_problem: string | null; mapping_problem: string | null }
}

/** GET /v1/rules/{id}. */
export interface Rule {
  id: string
  default_severity: Severity
  description: string
  segment: string
  field: string | null
  crrg_ref: string
  explanation: RuleExplanationBody
}

export async function listRules(): Promise<RulesList> {
  return api<RulesList>('/rules')
}

export async function getRule(id: string): Promise<Rule> {
  return api<Rule>(`/rules/${ruleIdSegment(id)}`)
}
